import React, { useState } from "react";

import EvidenceVideo from "./EvidenceVideo";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { evidenceTypes } from "./CONSTANTS";
import {
  AiFillFileExcel,
  AiOutlineFile,
  AiOutlineFileJpg,
  AiOutlineFilePdf,
  AiOutlineFileWord,
} from "react-icons/ai";
import { Button, Modal, Row } from "react-bootstrap";
import { FcVideoFile } from "react-icons/fc";
import { fileExtention } from "app/_helpers/helper";

const docType = (name, size = 50, color = "", classNam = "") => {
  // let extenstion = path.extname(name);
  let extenstion = fileExtention(name);
  extenstion = extenstion ? extenstion.toLowerCase() : extenstion;

  if (extenstion) {
    if (extenstion === "jpg" || extenstion == "jpeg" || extenstion == "jpeg") {
      return <AiOutlineFileJpg size={size} color={color} className={classNam} />;
    } else if (extenstion === "pdf") {
      return <AiOutlineFilePdf size={size} color={color} className={classNam} />;
    } else if (extenstion === "doc" || extenstion == "docx") {
      return <AiOutlineFileWord size={size} color={color} className={classNam} />;
    } else if (extenstion === "xls" || extenstion == "xlsx") {
      return <AiFillFileExcel size={size} color={color} className={classNam} />;
    } else {
      return <AiOutlineFile size={size} color={color} className={classNam} />;
    }
  }
};

const EvidencePreview = ({ type, file, size }) => {
  const [showManageModal, setShowManageModal] = useState(false);
  //   evidenceTypes[type] === evidenceTypes.audio ? (
  //     <div>
  //       <audio className="audio-element evidenceaudio" src={`${URL_CONFIG.IMG_URL}${file.document_name}`} source controls />
  //     </div>
  //   ) :
  return (
    <>
      {evidenceTypes[type] === evidenceTypes.video ? (
        // <EvidenceVideo
        //   src={`${URL_CONFIG.IMG_URL}${file.document_name}`}
        //   title={file.real_document_name}
        // />
        <FcVideoFile size={25} onClick={() => setShowManageModal(true)} />
      ) : type === "Document" || type === "document" ? (
        <div>
          {/* <audio className="audio-element evidenceaudio" src={`${URL_CONFIG.IMG_URL}${file.document_name}`} source controls /> */}
          <span
            onClick={() =>
              window.open(`${URL_CONFIG.IMG_URL}${file.document_name}`, "_blank")
            }
          >
            {docType(file?.document_name, size)}
          </span>
        </div>
      ) : (
        <img
          // onClick={() =>
          //   window.open(`${URL_CONFIG.IMG_URL}${file.document_name}`, "_blank")
          // }
          onClick={() => setShowManageModal(true)}
          className="evidenceImg"
          src={`${URL_CONFIG.IMG_URL}${file.document_name}`}
          alt={file.description}
        />
      )}

      <Modal show={showManageModal} onHide={() => setShowManageModal(false)} size="lg">
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <Row className="mb-3">
              <div className="popupImgVideo">
                {evidenceTypes[type] === evidenceTypes.video ? (
                  <EvidenceVideo
                    src={`${URL_CONFIG.IMG_URL}${file.document_name}`}
                    title={file.real_document_name}
                    hideClass
                  />
                ) : (
                  <img
                    className=""
                    src={`${URL_CONFIG.IMG_URL}${file.document_name}`}
                    alt={file.description}
                    // width={"80px"}
                  />
                )}
              </div>
            </Row>
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowManageModal(false);
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EvidencePreview;
